export var MULTI_PARAGRAPH_MAX_HEIGHT = 300;